<template>
  <div>
    <b-dropdown
      right
      no-caret
      variant="link"
      class="float-right nav-link p-0"
      :class="zindexClass"
    >
      <template
        slot="button-content"
      >
        <div
          class="flex-container"
        >
          <i class="icon">
            <icon-globe v-if="icon === 'globe'" />
            <icon-chevron-down v-else-if="icon === 'chevrondown'" />
          </i>
          <em v-if="first">{{ first }}</em>
          <em v-else>{{ $t(`common:languages.${activeLanguage}`) }}</em>
        </div>
      </template>

      <b-dropdown-item
        v-for="(language,index) in languages"
        :key="index"
        data-ident="languageSelect"
        @click="languageSelect(language.value)"
      >
        {{ language.text }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/dropdown.scss';
import DeviceHelper from 'mixins/DeviceHelper';

/* ICONS */
import IconGlobe from 'ICON:IconGlobe';
import IconChevronDown from 'ICON:IconChevronDown';

export default {
  name: 'LanguageSwitch',
  i18nOptions: { namespaces: ['common'], keyPrefix: 'languages', language: 'en' },
  components: {
    BDropdown, BDropdownItem, IconGlobe, IconChevronDown,
  },
  mixins: [DeviceHelper],
  props: {
    languageCodes: {
      type: Array,
      default: () => ['de'],
    },
    translatorCodes: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: 'globe',
    },
    first: {
      type: String,
      default: '',
    },
    reset: {
      type: String,
      default: '',
    },
    zindexClass: {
      type: [String, Number],
      default: 'zindex-on',
    },
  },
  data() {
    return {
      selectedLang: false,
    };
  },
  computed: {
    stateLanguage() {
      return this.$store.state.app.currentLanguage;
    },
    activeLanguage() {
      return this.selectedLang || this.$store.state.app.currentLanguage;
    },
    languages() {
      const returnLanguages = [];
      this.languageCodes.forEach((iso) => {
        returnLanguages.push({ value: iso, text: this.$t(`common:languages.${iso}`) });
      });
      this.translatorCodes.forEach((iso) => {
        returnLanguages.push({ value: iso, text: this.$t(`common:languages.${iso}`) });
      });
      if (this.reset) {
        returnLanguages.push({ value: this.reset, text: this.$t(`common:languages.${this.reset}`) });
      }
      const map = new Map();
      const distinctCodes = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of returnLanguages) {
        if (!map.has(item.value)) {
          map.set(item.value, true); // set any value to Map
          distinctCodes.push({
            value: item.value,
            text: item.text,
          });
        }
      }
      return distinctCodes;
    },
    smallDevice() { return ['xs', 'sm'].includes(this.dh_breakpoint); },
  },
  watch: {
    stateLanguage: {
      handler: 'setLanguage',
    },
  },
  methods: {
    languageSelect(val) {
      if (val === 'reset') {
        this.$emit('reset');
      } else {
        this.selectedLang = val;
        this.$emit('lang-changed', val);
      }
    },
    setLanguage() {
      this.selectedLang = this.stateLanguage;
    },
  },
};
</script>
<style  lang="scss" scoped>
  .zindex-on{
    z-index:1150;
  }
  .zindex-auto{
    z-index:auto;
  }
  .flex-container{
      line-height:inherit !important;
      height:inherit !important;
      font-size:inherit;
  }
  /deep/.icon{
      color:inherit;
      vertical-align:baseline;
  }
  /deep/ em{
      color:inherit;
      vertical-align: middle;
      font-style: normal;
  }
  /deep/ .btn.btn-link {
    color: inherit;
    // font-size:inherit;
    // line-height:inherit;
  }

</style>
